import { listReceivedMail } from "src/aws/customAPI"
import { execApi } from "src/apis/execApi"
import { appInfo } from "src/constants/AppInfo"

export type CheckLatestInboxContactParams = {
  accessToken: string
  myMemberId: string
}

export type LatestContactInfo = {
  id: string
  sentAt: string
}

/**
 * 受信トレイの最新の連絡情報を取得（1件のみ）
 * バックグラウンド復帰時の新着チェック用
 */
export const checkLatestInboxContact = async (
  params: CheckLatestInboxContactParams
): Promise<LatestContactInfo | null> => {
  const result = await execApi(
    () =>
      listReceivedMail(params.accessToken, {
        teamMemberId: params.myMemberId,
        filter: {},
        count: 1, // 最新1件のみ取得
        appInfo,
      }),
    (res) => {
      const items = res.searchTeamMemberMails.items
      if (items.length === 0) {
        return null
      }
      const latestMail = items[0]
      return {
        id: latestMail.mail.id,
        sentAt: latestMail.mail.sentAt,
      }
    },
    {
      identifiers: ["checkLatestInboxContact", "listReceivedMail"],
    }
  )

  if (!result.isOk) {
    console.error("[checkLatestInboxContact] API error:", result.error)
    return null
  }

  return result.content
}
